<template>
  <svg width="20"
       height="17"
       viewBox="0 0 20 17"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M13.2695 5.41992C14.2188 5.41992 15.0361 4.82227 15.3789 3.99609H18.2705C18.71 3.99609 19.0791 3.60938 19.0791 3.14355C19.0791 2.67773 18.71 2.2998 18.2705 2.2998H15.3789C15.0449 1.46484 14.2275 0.867188 13.2695 0.867188C12.3115 0.867188 11.4941 1.46484 11.1602 2.2998H1.74707C1.28125 2.2998 0.912109 2.67773 0.912109 3.14355C0.912109 3.60938 1.28125 3.99609 1.74707 3.99609H11.1602C11.5029 4.82227 12.3203 5.41992 13.2695 5.41992ZM13.2695 4.22461C12.6631 4.22461 12.1885 3.74121 12.1885 3.14355C12.1885 2.52832 12.6631 2.05371 13.2695 2.05371C13.8848 2.05371 14.3506 2.52832 14.3506 3.14355C14.3506 3.74121 13.8848 4.22461 13.2695 4.22461ZM1.7207 7.78418C1.28125 7.78418 0.912109 8.16211 0.912109 8.62793C0.912109 9.08496 1.28125 9.47168 1.7207 9.47168H4.70898C5.05176 10.3154 5.86914 10.9043 6.82715 10.9043C7.77637 10.9043 8.59375 10.3154 8.93652 9.47168H18.2441C18.71 9.47168 19.0791 9.09375 19.0791 8.62793C19.0791 8.16211 18.71 7.78418 18.2441 7.78418H8.93652C8.59375 6.94922 7.77637 6.36035 6.82715 6.36035C5.86914 6.36035 5.05176 6.94922 4.70898 7.78418H1.7207ZM6.82715 9.71777C6.2207 9.71777 5.7373 9.23438 5.7373 8.62793C5.7373 8.0127 6.2207 7.54688 6.82715 7.54688C7.43359 7.54688 7.9082 8.0127 7.9082 8.62793C7.9082 9.23438 7.43359 9.71777 6.82715 9.71777ZM13.2695 16.3887C14.2275 16.3887 15.0449 15.791 15.3789 14.9561H18.2705C18.71 14.9561 19.0791 14.5781 19.0791 14.1123C19.0791 13.6377 18.71 13.2686 18.2705 13.2686H15.3789C15.0449 12.4336 14.2275 11.8359 13.2695 11.8359C12.3203 11.8359 11.4941 12.4336 11.1602 13.2686H1.74707C1.28125 13.2686 0.912109 13.6465 0.912109 14.1123C0.912109 14.5693 1.28125 14.9561 1.74707 14.9561H11.1602C11.4941 15.791 12.3115 16.3887 13.2695 16.3887ZM13.2695 15.1934C12.6631 15.1934 12.1885 14.71 12.1885 14.1123C12.1885 13.4971 12.6631 13.0312 13.2695 13.0312C13.8848 13.0312 14.3506 13.4971 14.3506 14.1123C14.3506 14.71 13.8848 15.1934 13.2695 15.1934Z"
          :fill="color"/>
  </svg>

</template>

<script>
export default {
  name: 'FiltersIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    },
    iconClass: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>

</style>
